import i18n from '@/plugins/i18n';
import {
  LINE_GRAPH,
  STATUS_LABEL,
  EDIT_MENU_KEY,
  DELETE_MENU_KEY,
  RUN_MENU_KEY,
  ADD_WIDGET_MENU_KEY,
  ALERT_MENU_KEY,
} from '@/components/Settings/Custom-DB-query/CustomDBQuery.constants';

export const DatabaseTypes = [
  { key: 'MY', label: i18n.global.t('setting.mySql') },
  { key: 'MS', label: i18n.global.t('setting.msSql') },
  { key: 'PG', label: i18n.global.t('setting.postgreSql') },
];
export const queryTableHeader = [
  { name: i18n.global.t('setting.name'), key: 'metricName', width: '30%' },
  { name: i18n.global.t('setting.query'), key: 'query', width: '75%' },
  { name: '', key: 'actions', width: '5%' },
];
export const runQueryTableHeader = [
  { name: i18n.global.t('setting.message'), key: 'value', width: '80%' },
  { name: i18n.global.t('setting.timestamp'), key: 'time', width: '20%' },
];

export const addwidgetOptions = [
  {
    iconName: 'lineGraph',
    label: i18n.global.t('setting.lineGraph'),
    key: LINE_GRAPH,
    dispGif: false,
  },

  {
    iconName: 'statusLabel',
    label: i18n.global.t('setting.label'),
    key: STATUS_LABEL,
    dispGif: false,
  },
];

export const dashboardDefulatOption = {
  name: i18n.global.t('setting.select'),
  id: '',
};
export const addWidgetDefulatData = {
  addDashboardInfo: {
    widgetName: '',
    dashboardName: '',
    dashboard: dashboardDefulatOption,
    widgetType: '',
  },
  widgetFormData: {
    isDashNameValid: true,
    isDashboardValid: true,
    isCreateOrUpdate: true,
    isQueryExecuted: false,
    isNewDashboard: false,
  },
  queryFormInfo: {
    metricName: '',
    query: '',
    dbType: '',
    serviceId: '',
    serviceName: '',
  },
};
export const customDBMenuItems = [
  {
    key: EDIT_MENU_KEY,
    label: i18n.global.t('setting.edit'),
    icon: 'editFilled',
  },
  {
    key: DELETE_MENU_KEY,
    label: i18n.global.t('setting.delete'),
    icon: 'deleteFilled',
  },
  {
    key: RUN_MENU_KEY,
    label: i18n.global.t('setting.runQuery'),
    icon: 'runQuery',
  },
  {
    key: ADD_WIDGET_MENU_KEY,
    label: i18n.global.t('setting.addWidget'),
    icon: 'addCusWidget',
  },
  {
    key: ALERT_MENU_KEY,
    label: i18n.global.t('setting.viewAlerts'),
    icon: 'alert',
  },
];
